import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const TradingRules = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.TradingRules[key][currentLang];

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content trading-page">
          <h1>🧾 {t("title")}</h1>
          <p>{t("intro")}</p>

          <div className="highlight-box">
            <h2>{t("generalTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("oneAccount")}</li>
              <li>{t("noFake")}</li>
              <li>{t("respectOthers")}</li>
            </ul>

            <h2>{t("tradingTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("respondTimely")}</li>
              <li>{t("honorDeals")}</li>
              <li>{t("markShipped")}</li>
            </ul>

            <h2>{t("violationsTitle")}</h2>
            <p>{t("violationsText")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingRules;
